// Frontend client for the Box-backed portal API.
// Uses real session cookie (set by /api/auth/* endpoints) — auth is automatic
// because credentials: 'include' on fetch sends the cookie. No client-side header
// management needed.

export async function fetchDocuments() {
  const res = await fetch("/api/box/list", { credentials: "include" });
  if (!res.ok) {
    let msg = `Documents fetch failed (${res.status})`;
    try { msg = (await res.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  const json = await res.json();
  return json.documents || [];
}

// Build the URL the browser navigates to for download. Server validates auth +
// LP scope, then 302 redirects to a Box-signed URL.
export function downloadUrl(fileId) {
  return `/api/box/download?id=${encodeURIComponent(fileId)}`;
}
